import styles from "../../../../styles/Components/new-insight/signals-section/signals-table/SignalCell.module.css";
import useServiceStatus from "../../../../hooks/useServiceStatus";
import HideContentIcon from "../../../mini-app/shared/HideContentIcon";
import React from "react";
import { RiExchangeFundsLine } from "react-icons/ri";
import { signalStrengthConverter } from "../../../trading-assistant/SignalStrengthUi";
import { useRelativeTime } from "../../../../hooks/useRelativeTime";
import { MdAccessTime } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import HiddenContent from "../../../../ui/HiddenContent";
import { Tooltip } from "antd";

function SignalCell({ signal = {} }) {
  const { isActive } = useServiceStatus("insight");

  const {
    suggestion = "",
    strength = "",
    date,
    coin,
    name,
    signal_description,
    description,
  } = signal;
  const hasData = !!suggestion;
  const signalDate = useRelativeTime(date || "");

  const navigate = useNavigate();

  const clickHandler = () => {
    if (!hasData) return;
    navigate(`/insight/chart?symbol=${coin}`);
  };

  return (
    <div
      className={`${styles.container} ${isActive && hasData ? styles?.[suggestion?.toLowerCase()] : ""} ${!hasData || !isActive ? styles.emptyBox : ""}`}
      style={{ cursor: `${hasData ? "pointer" : "unset"}` }}
      onClick={clickHandler}
    >
      {!isActive ? (
        <HiddenContent service="insai" />
      ) : hasData ? (
        <div className={styles.signalInfo}>
          <Tooltip title={description} color="#0c4cfc">
            <span className={`${styles.infoItem} ${styles.strengthLabel}`}>
              {signalStrengthConverter?.[strength]}
            </span>
            <span
              className={styles.infoItem}
              style={{ alignItems: "flex-start", textAlign: "start" }}
            >
              {name}
            </span>
            <span
              className={styles.infoItem}
              style={{ alignItems: "flex-start", textAlign: "start" }}
            >
              {signal_description}
            </span>
          </Tooltip>
          {/*<span className={styles.infoItem}>*/}
          {/*  {" "}*/}
          {/*  <MdAccessTime />*/}
          {/*  {signalDate}*/}
          {/*</span>*/}
        </div>
      ) : (
        <RiExchangeFundsLine
          color="lightgrey"
          style={{ margin: "auto" }}
          size={25}
        />
      )}

      {isActive && hasData && (
        <span
          className={`${styles.predictionBadge} ${styles?.[suggestion?.toLowerCase()]}`}
        >
          {suggestion}
        </span>
      )}
    </div>
  );
}

export default SignalCell;
